var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNivi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "323px",
    height: "501px",
    viewBox: "0 0 323 501",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 3") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icons",
    transform: "translate(-1499.000000, -163.000000)",
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(1499.619700, 163.869961)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path-8",
    d: "M20.5480855 0 81.4794322 0 144.30813 89.2821473 144.30813 0 217.283164 0 217.283164 230.130039 156.037463 230.630039 92.2544766 142.483754 92.2544766 230.630039 20.5480855 230.630039z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-9",
    d: "M241.822422 0 319.25174 0 319.25174 230.130039 241.822422 230.130039z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-10",
    d: "M0 270.041306 80.0620325 270.041306 118.915625 370.154633 157.763603 270.041306 237.345685 270.041306 148.818548 500.130039 88.4569681 500.130039z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-11",
    d: "M244.234499 270.041306 321.465788 270.041306 321.465788 500.130039 244.234499 500.130039z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNivi);
export default __webpack_public_path__ + "static/media/nivi.865fe1f8649150560dce5ee32d67ea73.svg";
export { ForwardRef as ReactComponent };